import { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function InternetTraffic() {
  const [data, setData] = useState(null);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Internet Traffic',
      },
    },
  };

  useEffect(() => {
    fetch("https://internet-traffic-worker.abramojo02.workers.dev/traffic-change")
      .then((res) => res.json())
      .then((internetTrafficData) => {

        const labels = internetTrafficData.data.total.timestamps
        setData(
          {
            labels,
            datasets: [
              {
                label: 'Total Traffic',
                data: internetTrafficData.data.total.values,
                borderColor: 'rgb(164, 36, 59)',
                backgroundColor: 'rgba(164, 36, 59, 0.5)',
              },
              {
                label: 'HTTP Traffic',
                data: internetTrafficData.data.http.values,
                borderColor: 'rgb(39, 62, 71)',
                backgroundColor: 'rgba(39, 62, 71, 0.5)',
              }
            ]
          }
        );
      })
  }, [])

  if (!data) {
    return (<div>Loading...</div>);
  }
  return (<Line data={data} options={options} />);
}

export default InternetTraffic;
